import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Ampersands: IconNode = [
  'svg',
  defaultAttributes,
  [
    [
      'path',
      { d: 'M10 17c-5-3-7-7-7-9a2 2 0 0 1 4 0c0 2.5-5 2.5-5 6 0 1.7 1.3 3 3 3 2.8 0 5-2.2 5-5' },
    ],
    [
      'path',
      { d: 'M22 17c-5-3-7-7-7-9a2 2 0 0 1 4 0c0 2.5-5 2.5-5 6 0 1.7 1.3 3 3 3 2.8 0 5-2.2 5-5' },
    ],
  ],
];

export default Ampersands;
